var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20539_163637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 6.25V14.5833C31.25 15.1359 31.4695 15.6658 31.8602 16.0565C32.2509 16.4472 32.7808 16.6667 33.3333 16.6667H41.6667",
    stroke: "#6024B8",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 35.4167H22.9167C21.8116 35.4167 20.7518 34.9777 19.9704 34.1963C19.189 33.4149 18.75 32.3551 18.75 31.25V10.4167C18.75 9.3116 19.189 8.25179 19.9704 7.47039C20.7518 6.68899 21.8116 6.25 22.9167 6.25H31.25L41.6667 16.6667V31.25C41.6667 32.3551 41.2277 33.4149 40.4463 34.1963C39.6649 34.9777 38.6051 35.4167 37.5 35.4167Z",
    stroke: "#6024B8",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3366 35.4168V39.5835C33.3366 40.6886 32.8976 41.7484 32.1162 42.5298C31.3348 43.3112 30.275 43.7502 29.1699 43.7502H14.5866C13.4815 43.7502 12.4217 43.3112 11.6403 42.5298C10.8589 41.7484 10.4199 40.6886 10.4199 39.5835V18.7502C10.4199 17.6451 10.8589 16.5853 11.6403 15.8039C12.4217 15.0225 13.4815 14.5835 14.5866 14.5835H18.7533",
    stroke: "#6024B8",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20539_163637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/total-orders.8b8d5619.svg";
export { ForwardRef as ReactComponent };